import type {JSX, ReactElement, ReactNode} from 'react'
import React, {cloneElement, isValidElement} from 'react'
import {clsx} from 'clsx'
import {useWindowSize} from '@/_new-code/utilities/hooks/use-window-size'

interface HeaderBlockCarouselSlideProps {
	className?: string
	button: ReactNode
	image: ReactElement<{
		className: string
	}> | null
	subheading: string
	heading: string
	url: string
	headingUrl: string
	isContentOnTopOfImage?: boolean
}

export const HeaderBlockCarouselSlide = ({
	className = '',
	button,
	image,
	subheading,
	heading,
	url,
	headingUrl,
	isContentOnTopOfImage,
}: HeaderBlockCarouselSlideProps): JSX.Element => {
	const size = useWindowSize()
	if (!isContentOnTopOfImage) {
		return (
			<div className={clsx('relative', className)}>
				<a href={url}>
					{isValidElement(image)
						? cloneElement(image, {
								className: 'w-full object-cover',
							})
						: null}
				</a>
				<div className="bottom-0 w-full pl-6 pr-6">
					<div className="slide-text-block mx-auto max-w-screen-xl items-center justify-between p-4 md:flex">
						<div className="md:mr-1">
							<a href={url}>
								<p>{subheading}</p>
							</a>
							<a href={headingUrl}>
								<h2>{heading}</h2>
							</a>
						</div>
						{Boolean(button) && button}
					</div>
				</div>
			</div>
		)
	}
	if (!size.isMobile) {
		return (
			<div className={clsx('relative', className)}>
				{subheading && heading ? (
					<>
						<div className="absolute h-full w-full">
							<div className="container-wide flex h-full items-center">
								<div className="flex h-full w-full items-center">
									<div className="items-left max-w-2/3 w-1/2 flex-col justify-between rounded-lg bg-white p-2 md:flex lg:w-1/3 lg:p-4 2xl:h-[210px]">
										<div className="pb-4 md:mr-1">
											<a href={headingUrl}>
												<h2 className="mb-2 text-2xl leading-none text-black lg:mb-4">
													{heading}
												</h2>
											</a>
											<a href={url}>
												<p className="text-black">
													{subheading}
												</p>
											</a>
										</div>
										{Boolean(button) && button}
									</div>
								</div>
							</div>
						</div>
						<a href={url}>
							{isValidElement(image)
								? cloneElement(image, {
										className: 'w-full object-cover',
									})
								: null}
						</a>
					</>
				) : (
					<a href={url}>
						{isValidElement(image)
							? cloneElement(image, {
									className: 'w-full object-cover',
								})
							: null}
					</a>
				)}
			</div>
		)
	}

	return (
		<div className={clsx('relative', className)}>
			{subheading && heading ? (
				<>
					<a href={url}>
						{isValidElement(image)
							? cloneElement(image, {
									className: 'w-full object-cover',
								})
							: null}
					</a>
					<div className="bottom-0 w-full pl-6 pr-6">
						<div className="slide-text-block mx-auto max-w-screen-xl items-center justify-between p-4 md:flex">
							<div className="md:mr-1">
								<a href={url}>
									<p>{subheading}</p>
								</a>
								<a href={headingUrl}>
									<h2 className="mb-4">{heading}</h2>
								</a>
							</div>
							{Boolean(button) && button}
						</div>
					</div>
				</>
			) : (
				<a href={url}>
					{isValidElement(image)
						? cloneElement(image, {
								className: 'w-full object-cover',
							})
						: null}
				</a>
			)}
		</div>
	)
}
